import { getAuthHeaders, tempMeeApi } from '~/services/api';

/**
 * Dismiss the Best-in-Dental winner popup
 * Makes a PATCH request to mark the most recent undismissed popup as dismissed
 * Backend automatically identifies and dismisses the most recent winner popup
 *
 * @returns Promise<void> - 204 No Content response
 */
export const dismissWinnerPopup = async (): Promise<void> => {
  const headers = await getAuthHeaders();

  // Backend dismisses most recent popup automatically - no request body needed
  await tempMeeApi.patch<void>('/users/best-in-dental/winner-popup', {}, { headers });

  // 204 No Content - returns void
};
